import { addProp } from "@pnp/odata";
import { _Group } from "../groups/types.js";
import { Members } from "./types.js";
addProp(_Group, "owners", Members, "owners");
addProp(_Group, "members", Members);
//# sourceMappingURL=groups.js.map